import {
    GET_FUNDING_SOURCE_BY_ID_SUCCESS,
    GET_FUNDING_SOURCE_SUCCESS,
    GET_FUNDING_SOURCE_SERVICE_BY_ID_SUCCESS,
    GET_FUNDING_MODIFIERS_SUCCESS,
    GET_FUNDING_SOURCE_CLIENTS_SUCCESS,
    REMOVE_FUNDING_SOURCE_SERVICES,
    GET_PAYER_CAPABILITIES_SUCCESS,
    GET_PAYER_CAPABILITIES, GET_FUNDING_UNIQUE_SERVICES_SUCCESS,
} from './fundingSource.types';

const initialState = {
    fundingSourceList: [],
    fSelect: [],
    fundingSourceServices: [],

    serviceChargeRates: null,
    fsClients: [],
    payerCapabilities: [],
    fundingUniqueServices: [],
};

export const fundingSourceReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Founding Source */
        case GET_FUNDING_SOURCE_SUCCESS:
            return {
                ...state,
                fSelect: action.payload,
                fundingSourceList: action.payload,
            };

        case GET_FUNDING_SOURCE_BY_ID_SUCCESS:
            return {
                ...state,
                fundingSourceItem: action.payload,
            };

        case GET_FUNDING_SOURCE_CLIENTS_SUCCESS:
            return {
                ...state,
                fsClients: action.payload,
            };

        case GET_PAYER_CAPABILITIES:
            return {
                ...state,
                payerCapabilities: [],
            };

        case GET_PAYER_CAPABILITIES_SUCCESS:
            return {
                ...state,
                payerCapabilities: action.payload,
            };
        /** End */

        /** Founding Source Service */
        case GET_FUNDING_SOURCE_SERVICE_BY_ID_SUCCESS:
            return {
                ...state,
                fundingSourceServices: action.payload,
            };

        case REMOVE_FUNDING_SOURCE_SERVICES:
            return {
                ...state,
                fundingSourceServices: [],
            };
        /** End */

        case GET_FUNDING_MODIFIERS_SUCCESS:
            return {
                ...state,
                serviceChargeRates: action.payload,
            };

        case GET_FUNDING_UNIQUE_SERVICES_SUCCESS:
            return {
                ...state,
                fundingUniqueServices: action.payload,
            };

        default:
            return state;
    }
};
